import { store } from '../../../redux/store';
import { veevaApi } from '../../../redux/RTK/veevaReconcileSlice';

export async function fetchDashboardMetrics() {
  const promise = store.dispatch(
    veevaApi.endpoints.getDashboardMetrics.initiate()
  );
  try {
    const raw = await promise.unwrap();
    const data = raw ?? {};
    const aoc = Number(
      data['aoc_status_mismatches_count'] ?? data['aocStatusMismatchesCount']
    );
    const missing = Number(
      data['delivered_missing_delivery_date_count'] ??
        data['deliveredMissingDeliveryDateCount']
    );
    const openAocs = Number(
      data['open_aocs_mismatch_count'] ?? data['openAocsMismatchCount']
    );
    return {
      aoc_status_mismatches_count: Number.isFinite(aoc) ? Math.floor(aoc) : 0,
      delivered_missing_delivery_date_count: Number.isFinite(missing)
        ? Math.floor(missing)
        : 0,
      open_aocs_mismatch_count: Number.isFinite(openAocs)
        ? Math.floor(openAocs)
        : 0,
    };
  } catch (err) {
    if (err?.status === 404) {
      return {
        aoc_status_mismatches_count: 0,
        delivered_missing_delivery_date_count: 0,
        open_aocs_mismatch_count: 0,
      };
    }
    throw err;
  } finally {
    promise.unsubscribe();
  }
}
